"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var TemplateContainer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(TemplateContainer, _React$Component);

  function TemplateContainer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, TemplateContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(TemplateContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_template", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_templateSetter", function (cmp) {
      if (cmp) _this._template = cmp;
    });
    return _this;
  }

  (0, _createClass2["default"])(TemplateContainer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.anySelected !== nextProps.anySelected || this.props.itemSelected !== nextProps.itemSelected || this.props.item !== nextProps.item || this.props.template !== nextProps.template || this.props.commonProps !== nextProps.commonProps;
    }
  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this._template;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          item = _this$props.item,
          itemSelected = _this$props.itemSelected,
          anySelected = _this$props.anySelected,
          dragHandleProps = _this$props.dragHandleProps,
          commonProps = _this$props.commonProps;
      var Template = this.props.template;
      return _react["default"].createElement(Template, {
        ref: this._templateSetter,
        item: item,
        itemSelected: itemSelected,
        anySelected: anySelected,
        dragHandleProps: dragHandleProps,
        commonProps: commonProps
      });
    }
  }]);
  return TemplateContainer;
}(_react["default"].Component);

exports["default"] = TemplateContainer;
module.exports = exports.default;
module.exports.default = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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